import React, { useContext } from "react";
import { useDrag } from "react-dnd";
import AppContext from "../../context/AppContext";
import { toast } from "../../utils/toast";
import { Navigate, useNavigate } from "react-router-dom";
import translations from "../common/Translations";
import HoverTooltip from "../common/HoverTooltip";

const ItemTypes = {
  ELEMENT: "element",
};

export const DraggableElement = ({
  value,
  fieldName,
  onInputChange,
  icon,
  fieldType,
  isMandatory,
  isReport,
  cloneName,
  validationValues,
  isNewFieldDragged,
  setIsNewFieldDragged,
  setSelectedRadioId,
  tooltip,
  multiple ,accept,
  elementCategory = "basic",
}) => {
  const { theme, selectedOrgId, userType,langMode } = useContext(AppContext);

  const canDrag = !!selectedOrgId;
  const navigate = useNavigate()
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.ELEMENT,
    item: {
      fieldName,
      value,
      fieldType,
      isMandatory,
      isReport,
      cloneName,
      validationValues,
      tooltip,
      multiple,
      accept,
    },
    canDrag: () => {
      if (userType === 'super_admin' && !selectedOrgId) {
        navigate('/workflow')
        toast.error(translations[langMode].orgismissingnotdrag);
        return false; // Prevent dragging
      }
      return true;
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
    end: (item, monitor) => {
      setIsNewFieldDragged(false);
      setSelectedRadioId(null);
    },
  }));

  const categoryStyles = {
    basic: {
      card: "hover:border-[#BEDAF0] hover:bg-[#EAF3FB]/60",
      badge: "bg-[#EAF3FB] text-[#236DB4]",
    },
    selection: {
      card: "hover:border-[#D9CCFA] hover:bg-[#F1ECFD]/70",
      badge: "bg-[#F1ECFD] text-[#7B4FE0]",
    },
    media: {
      card: "hover:border-[#BFE6E4] hover:bg-[#E4F6F5]/70",
      badge: "bg-[#E4F6F5] text-[#0E8E8B]",
    },
    special: {
      card: "hover:border-[#F7E2BD] hover:bg-[#FDF3E2]/70",
      badge: "bg-[#FDF3E2] text-[#B8790A]",
    },
  };
  const cat = categoryStyles[elementCategory] || categoryStyles.basic;

  return (
    <div
      ref={drag}
      style={{ opacity: isDragging ? 0.5 : 1 }}
      className="relative z-0 hover:z-[280] focus-within:z-[280]"
    >
      <HoverTooltip text={tooltip} position="top" wrapperClassName="flex w-full">
      <div
        className={`relative group mb-2 flex w-full cursor-grab items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-start font-semibold shadow-sm transition duration-200 active:cursor-grabbing ${cat.card} ${theme === "dark"
          ? "dark-mode"
          : theme === "high-contrast"
            ? "high-contrast"
            : ""
          }`}
      >
        <span className={`inline-flex h-6 w-6 items-center justify-center rounded-md ${cat.badge}`}>
          {icon}
        </span>
        <h6 className="hidden text-[12.5px] font-semibold leading-5 text-slate-700 sm:block">{fieldName?.charAt(0)?.toUpperCase() + fieldName?.slice(1)}</h6>
      </div>
      </HoverTooltip>
    </div>
  );
};
